module.exports = __webpack_public_path__ + "img/humidity2.a73953a1.png";